import { apiRequest } from '../apiRequest';
import { LOGIN_ENDPOINT, CHANGE_PASSWORD_ENDPOINT } from '../urls';

export const login = (data) => {
	return apiRequest('POST', LOGIN_ENDPOINT, data);
}

export const changePassword = (data) => {
	return apiRequest('POST', CHANGE_PASSWORD_ENDPOINT, data);
}

